import {SELECTED_MODE} from '@/constants/main';

const formattedTopLiveList = (broad, count, priorityList = []) => {
  if (!broad || broad.length === 0) {
    return [];
  }
  const formattedPriorityList = priorityList.map(
    ({
      totalViewCnt,
      userNick,
      broadTitle,
      broadNo,
      broadThumb,
      isPassword,
      broadGrade,
      subscriptionOnly,
      ...rest
    }) => ({
      ...rest,
      viewCount: totalViewCnt,
      userNickname: userNick,
      title: broadTitle,
      broadcastId: broadNo,
      thumbnailSrc: broadThumb,
      isPassword: isPassword === 'Y' ? 1 : 0,
      isAdult: Number(broadGrade),
      isBanner: false,
      isSubscriptionOnly: Number(subscriptionOnly) > 0,
    }),
  );

  const formattedList = broad.map(
    ({
      totalViewCnt,
      userNick,
      broadTitle,
      broadNo,
      broadThumb,
      isPassword,
      broadGrade,
      subscriptionOnly,
      ...rest
    }) => ({
      ...rest,
      viewCount: totalViewCnt,
      userNickname: userNick,
      title: broadTitle,
      broadcastId: broadNo,
      thumbnailSrc: broadThumb,
      isPassword: isPassword === 'Y' ? 1 : 0,
      isAdult: Number(broadGrade),
      isBanner: false,
      isSubscriptionOnly: Number(subscriptionOnly) > 0, // 0: 일반방송, 2: 티어2 시청가능방송
    }),
  );

  const filteredList = formattedList.filter((item) => {
    // 비번방 아니고 && 성인방송 아니고 && 유료방송 아니고 숨기기 하지않은 스트리머 방송만 추출
    return (
      Number(item.broadType) !== 40 &&
      Number(item.isPassword) === 0 &&
      Number(item.isAdult) === 0 &&
      !item.isSubscriptionOnly &&
      item.broadCateNo !== '00130000' //토크&캠방 카테고리 제외
    );
  });

  if (filteredList.length <= count) {
    return filteredList;
  }

  const priorityItems = formattedPriorityList;

  // priorityList에 포함되지 않은 방송만 선택
  const priorityIds = new Set(priorityItems.map((v) => String(v.userId)));

  const nonPriorityItems = filteredList.filter(
    (item) => !priorityIds.has(String(item.userId)),
  );

  // 부족한 개수 계산
  const needCount = Math.max(count - priorityItems.length, 0);

  // 랜덤 추출
  const randomItems = [];
  const used = new Set();

  while (randomItems.length < needCount && nonPriorityItems.length > 0) {
    const index = Math.floor(Math.random() * nonPriorityItems.length);
    if (!used.has(index)) {
      used.add(index);
      randomItems.push(nonPriorityItems[index]);
    }
  }
  console.log('needCount =', needCount);
  console.log('priorityItems => ', priorityItems);
  console.log('randomItems => ', randomItems);
  return [...priorityItems, ...randomItems];
};

export const buildTopLiveList = ({
  selectedMode,
  broadList,
  isSimplifyMode,
  banner,
  topLiveList,
  priorityList,
}) => {
  let result = {
    count: 0,
    list: [],
  };

  const ad = banner?.main?.creatives?.[0];

  //인기모드
  if (selectedMode === SELECTED_MODE.POPULAR) {
    //간소화 일 경우
    if (isSimplifyMode) {
      // 간소화 모드 > 광고 있을때 광고만 노출
      if (banner.main.exist && ad) {
        const onlyAd = [ad];
        result = {
          count: onlyAd.length,
          list: onlyAd,
        };
      }
    }
    //간소화 아닐 경우
    else {
      //광고 있을때
      if (banner.main.exist && ad) {
        // topLiveList 비어있을때
        if (topLiveList.count === 0) {
          const formattedList = formattedTopLiveList(
            broadList,
            3,
            priorityList,
          );
          formattedList.push(ad);
          result = {
            count: formattedList.length,
            list: formattedList,
          };
        }
        // topLiveList 광고 없이 콘텐츠만 있는 경우
        else if (topLiveList.list.every((item) => !item.isBanner)) {
          const updatedList = topLiveList.list.slice(0, 3);
          updatedList.push(ad);
          result = {
            count: updatedList.length,
            list: updatedList,
          };
        }
      }
      // 광고 없을 경우
      else {
        const formattedList = formattedTopLiveList(broadList, 4, priorityList);
        result = {
          count: formattedList.length,
          list: formattedList,
        };
      }
    }
  }
  //선호 모드
  else if (selectedMode === SELECTED_MODE.PREFER) {
    //간소화
    if (isSimplifyMode) {
      //광고 있을때
      if (banner?.main?.exist && ad) {
        const onlyAd = [ad];
        result = {
          count: onlyAd.length,
          list: onlyAd,
        };
      }
    }
    //간소화 아닐경우
    else {
      const formattedList = broadList
        ? broadList.map(
            ({
              totalViewCnt,
              userNick,
              broadTitle,
              broadNo,
              broadThumb,
              ...rest
            }) => ({
              ...rest,
              viewCount: totalViewCnt,
              userNickname: userNick,
              title: broadTitle,
              broadcastId: broadNo,
              thumbnailSrc: broadThumb,
              isBanner: false,
            }),
          )
        : [];

      //광고있을때
      if (banner?.main?.exist && ad) {
        if (formattedList.length >= 4) {
          formattedList.splice(3, 1, ad);
        } else {
          formattedList.push(ad);
        }
      }
      result = {
        count: formattedList.length,
        list: formattedList,
      };
    }
  }

  return result;
};
